import { resolutions } from './constants';

export const initialHistory = {
  time: [],
  humidity: [],
  temp: [],
  co2: [],
  vpd: [],
  temp_leaf_current: [],
  vol_water_content: [],
  ec_root_zone: [],
  vol_water_content_2: [],
  ec_root_zone_2: [],
  vol_water_content_3: [],
  ec_root_zone_3: [],
  vol_water_content_4: [],
  ec_root_zone_4: [],
  hidden: {
    humidity: false,
    temp: false,
    co2: false,
    vpd: false,
    temp_leaf_current: false,
    vol_water_content: false,
    ec_root_zone: false,
    vol_water_content_2: false,
    ec_root_zone_2: false,
    vol_water_content_3: false,
    ec_root_zone_3: false,
    vol_water_content_4: false,
    ec_root_zone_4: false
  },
  resolution: resolutions.daily,
  progress: 0,
  last_ts: 0,
  pending_data: [],
  pending_transfer_id: null,
  transfer_mode: 'unknown',
  incomplete_final_chunk: false,
  orphan_final_chunk: null,
  request_in_flight: false,
  recovery_retry_count: 0,
  request_activity_at_ms: 0,
  abandoned_transfer_ids: []
};

export const initialFSStatus = {
  total_size: -1,
  free: -1,
  flash_status: -1,
  fs_status: -1
};
